import { transformDateValue } from 'core/js/FormUtils';
export const getProductcompositionView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let productcompositionList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Composition Name","fieldValue":transformDataValue(data.compositionname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Quantity","fieldValue":transformDataValue(data.quantity,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                              {"fieldLabel":"Quantity","fieldValue":transformDataValue(data.quantity,"string"), "fieldType":"string"},
              
              ]
          }

          productcompositionList.push(card);
  })
  return productcompositionList;
}